// Standardized table action icons
export const TABLE_ICONS = {
  EDIT: '✏️',
  DELETE: '🗑️', 
  VIEW: '👁️',
  PREVIEW: '👁️',
  ADD: '➕',
  LOADING: '⏳',
  WARNING: '⚠️',
  SUCCESS: '✅',
  ERROR: '❌',
  FILE: '📄',
  FOLDER: '📁',
  SEARCH: '🔍' ,
  IMAGE: '🖼️'
};

// Helper function to get consistent icon
export const getTableIcon = (action) => {
  return TABLE_ICONS[action.toUpperCase()] || action;
};
